// Fordham's undergraduate majors (#2840). Read on 2026-10-01 from the
// official Undergraduate Bulletin (bulletin.fordham.edu), the Majors tab of
// each college a first-year applicant can choose: Fordham College at Rose
// Hill, Fordham College at Lincoln Center, and the Gabelli School of
// Business, whose majors the bulletin lists by campus. Every "... Major" line
// kept with the word "Major" dropped; left out: minors, Gabelli
// concentrations, "Theology Religious Studies Second Major" (a second major
// only), the School of Professional and Continuing Studies (adult and
// part-time students), and Gabelli's Global Business major at Lincoln
// Center, which the bulletin says is open only to students admitted for fall
// 2025 or earlier. The bulletin's two public accounting tracks are written
// "Accounting - Public Accountancy Major (CPA-150 track)" and "Accounting -
// Public Accounting Major (120 credits)"; the second keeps its name without
// the parenthetical (the page copy rules keep the word out). The bulletin's
// lists name no degree type, so degree is null. The KB's majors list was the
// starting point; the bulletin wins.
const majors = {
    "slug": "fordham-university",
    "read": "2026-10-01",
    "intro": "Every major in Fordham's official Undergraduate Bulletin for its three undergraduate colleges that admit first-year students, grouped by college and campus. Minors, concentrations, second-major-only programs and graduate programs are left out.",
    "groups": [
        {
            "name": "Fordham College at Rose Hill",
            "source": {
                "label": "Fordham Undergraduate Bulletin, Fordham College at Rose Hill, Majors",
                "url": "https://bulletin.fordham.edu/undergraduate/rose-hill/"
            },
            "majors": [
                {
                    "name": "African and African American Studies",
                    "degree": null
                },
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Art History and Visual Arts Double",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Biological Sciences",
                    "degree": null
                },
                {
                    "name": "Chemistry",
                    "degree": null
                },
                {
                    "name": "Chinese Studies",
                    "degree": null
                },
                {
                    "name": "Classical Civilization",
                    "degree": null
                },
                {
                    "name": "Classical Languages",
                    "degree": null
                },
                {
                    "name": "Communication and Culture",
                    "degree": null
                },
                {
                    "name": "Comparative Literature",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Design and Technology",
                    "degree": null
                },
                {
                    "name": "Digital Technologies and Emerging Media",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "Engineering Physics",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Film and Television",
                    "degree": null
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "General Science",
                    "degree": null
                },
                {
                    "name": "German Language and Literature",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Humanitarian Studies",
                    "degree": null
                },
                {
                    "name": "Individualized",
                    "degree": null
                },
                {
                    "name": "Integrative Neuroscience",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Math & Economics",
                    "degree": null
                },
                {
                    "name": "International Political Economy",
                    "degree": null
                },
                {
                    "name": "International Studies",
                    "degree": null
                },
                {
                    "name": "Italian Language and Literature",
                    "degree": null
                },
                {
                    "name": "Italian Studies",
                    "degree": null
                },
                {
                    "name": "Journalism",
                    "degree": null
                },
                {
                    "name": "Latin American and Latino Studies",
                    "degree": null
                },
                {
                    "name": "Math and Computer & Information Sciences",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Medieval Studies",
                    "degree": null
                },
                {
                    "name": "Middle East Studies",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Physics",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Religious Studies",
                    "degree": null
                },
                {
                    "name": "Social Work",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish Language and Literature",
                    "degree": null
                },
                {
                    "name": "Spanish Studies",
                    "degree": null
                },
                {
                    "name": "Theology Religious Studies",
                    "degree": null
                },
                {
                    "name": "Urban Studies",
                    "degree": null
                },
                {
                    "name": "Visual Arts",
                    "degree": null
                },
                {
                    "name": "Visual Arts and Art History Double",
                    "degree": null
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "Fordham College at Lincoln Center",
            "source": {
                "label": "Fordham Undergraduate Bulletin, Fordham College at Lincoln Center, Majors",
                "url": "https://bulletin.fordham.edu/undergraduate/lincoln-center/"
            },
            "majors": [
                {
                    "name": "African and African American Studies",
                    "degree": null
                },
                {
                    "name": "American Studies",
                    "degree": null
                },
                {
                    "name": "Anthropology",
                    "degree": null
                },
                {
                    "name": "Art History",
                    "degree": null
                },
                {
                    "name": "Art History and Visual Arts Double",
                    "degree": null
                },
                {
                    "name": "Biochemistry",
                    "degree": null
                },
                {
                    "name": "Chinese Studies",
                    "degree": null
                },
                {
                    "name": "Classical Civilization",
                    "degree": null
                },
                {
                    "name": "Classical Languages",
                    "degree": null
                },
                {
                    "name": "Communication and Culture",
                    "degree": null
                },
                {
                    "name": "Comparative Literature",
                    "degree": null
                },
                {
                    "name": "Computer Science",
                    "degree": null
                },
                {
                    "name": "Dance",
                    "degree": null
                },
                {
                    "name": "Design and Technology",
                    "degree": null
                },
                {
                    "name": "Digital Technologies and Emerging Media",
                    "degree": null
                },
                {
                    "name": "Economics",
                    "degree": null
                },
                {
                    "name": "English",
                    "degree": null
                },
                {
                    "name": "Environmental Science",
                    "degree": null
                },
                {
                    "name": "Environmental Studies",
                    "degree": null
                },
                {
                    "name": "Film and Television",
                    "degree": null
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": null
                },
                {
                    "name": "German Language and Literature",
                    "degree": null
                },
                {
                    "name": "German Studies",
                    "degree": null
                },
                {
                    "name": "History",
                    "degree": null
                },
                {
                    "name": "Humanitarian Studies",
                    "degree": null
                },
                {
                    "name": "Individualized",
                    "degree": null
                },
                {
                    "name": "Integrative Neuroscience",
                    "degree": null
                },
                {
                    "name": "Interdisciplinary Math & Economics",
                    "degree": null
                },
                {
                    "name": "International Political Economy",
                    "degree": null
                },
                {
                    "name": "International Studies",
                    "degree": null
                },
                {
                    "name": "Italian Language and Literature",
                    "degree": null
                },
                {
                    "name": "Italian Studies",
                    "degree": null
                },
                {
                    "name": "Journalism",
                    "degree": null
                },
                {
                    "name": "Latin American and Latino Studies",
                    "degree": null
                },
                {
                    "name": "Math and Computer & Information Sciences",
                    "degree": null
                },
                {
                    "name": "Mathematics",
                    "degree": null
                },
                {
                    "name": "Medieval Studies",
                    "degree": null
                },
                {
                    "name": "Middle East Studies",
                    "degree": null
                },
                {
                    "name": "Music",
                    "degree": null
                },
                {
                    "name": "Natural Science",
                    "degree": null
                },
                {
                    "name": "Philosophy",
                    "degree": null
                },
                {
                    "name": "Political Science",
                    "degree": null
                },
                {
                    "name": "Psychology",
                    "degree": null
                },
                {
                    "name": "Religious Studies",
                    "degree": null
                },
                {
                    "name": "Social Work",
                    "degree": null
                },
                {
                    "name": "Sociology",
                    "degree": null
                },
                {
                    "name": "Spanish Language and Literature",
                    "degree": null
                },
                {
                    "name": "Spanish Studies",
                    "degree": null
                },
                {
                    "name": "Theatre",
                    "degree": null
                },
                {
                    "name": "Theology Religious Studies",
                    "degree": null
                },
                {
                    "name": "Urban Studies",
                    "degree": null
                },
                {
                    "name": "Visual Arts",
                    "degree": null
                },
                {
                    "name": "Visual Arts and Art History Double",
                    "degree": null
                },
                {
                    "name": "Women, Gender, and Sexuality Studies",
                    "degree": null
                }
            ]
        },
        {
            "name": "Gabelli School of Business, Rose Hill",
            "source": {
                "label": "Fordham Undergraduate Bulletin, Gabelli School of Business, Majors",
                "url": "https://bulletin.fordham.edu/undergraduate/gabelli-business/"
            },
            "majors": [
                {
                    "name": "Accounting - Public Accountancy (CPA-150 track)",
                    "degree": null
                },
                {
                    "name": "Accounting - Public Accounting",
                    "degree": null
                },
                {
                    "name": "Accounting Information Systems",
                    "degree": null
                },
                {
                    "name": "Applied Accounting and Finance",
                    "degree": null
                },
                {
                    "name": "Business Administration",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Information Systems",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                }
            ]
        },
        {
            "name": "Gabelli School of Business, Lincoln Center",
            "source": {
                "label": "Fordham Undergraduate Bulletin, Gabelli School of Business, Majors",
                "url": "https://bulletin.fordham.edu/undergraduate/gabelli-business/"
            },
            "majors": [
                {
                    "name": "Analytics and Information Technology",
                    "degree": null
                },
                {
                    "name": "Digital Media and Technology",
                    "degree": null
                },
                {
                    "name": "Entertainment and Media Management",
                    "degree": null
                },
                {
                    "name": "Finance",
                    "degree": null
                },
                {
                    "name": "Marketing",
                    "degree": null
                }
            ]
        }
    ]
};

export default majors;
